import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-home-stage-loader',
  standalone: true,
  templateUrl: './home-stage-loader.component.html',
  styleUrls: ['../home-stage.component.scss'],
  imports: [CommonModule, NgxSkeletonLoaderModule],
})
export class HomeStageLoaderComponent {}
